module.exports = __webpack_public_path__ + "assets/img/PC7.5e50dd7c.jpg";